import { Instance, SnapshotIn, types } from 'mobx-state-tree';

import { FORM_CHUNK_TYPES } from '@common/constants/ChunkTypes';

import Media from '../Media';
import Scorm from './Scorm';

const LessonWork = types.model('LessonWork', {
	id: types.identifierNumber,
	lesson_id: types.maybeNull(types.number),
	lesson_work_type: types.string,
	description: types.maybeNull(types.string),
});

const ChunkType = types.model('ChunkType', {
	id: types.identifierNumber,
	name: types.string,
});

const Chunk = types
	.model('Chunk', {
		id: types.identifierNumber,
		topic_num: types.optional(types.number, 1),
		scorms: types.optional(types.array(Scorm), []),
		lesson_work: types.maybeNull(LessonWork),
		chunk_type: types.maybeNull(ChunkType),
		name: types.optional(types.string, ''),
		title: types.maybeNull(types.string),
		description: types.maybeNull(types.string),
		sort_id: types.optional(types.number, 0),
		image_url: types.maybeNull(types.string),
		image: types.maybeNull(Media),
		video_url: types.maybeNull(types.string),
		video: types.maybeNull(Media),
		scorm_url: types.maybeNull(types.string),
		scorm: types.maybeNull(Media),
		file_url: types.maybeNull(types.string),
		file: types.maybeNull(Media),
		information_scorm: types.optional(types.boolean, false),
		slide_for_teacher: types.maybeNull(types.string),
		dictaphone_url: types.maybeNull(types.string),
		media_url: types.maybeNull(types.string),
		scorm_vendor: types.maybeNull(types.string),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		get isFormTypeChunk() {
			return FORM_CHUNK_TYPES.includes(self.chunk_type?.name.toLowerCase() || '');
		},
	}))
	.actions((self) => ({
		setSortId(sortId: number) {
			self.sort_id = sortId;
		},
	}));

export default Chunk;

export interface IChunkModel extends Instance<typeof Chunk> {}
export type IChunkSnapshotIn = SnapshotIn<typeof Chunk>;
